module.exports = __webpack_public_path__ + "img/invoices_reject.22ee39d4.png";